import script from "./LanguageToggleButtonC.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageToggleButtonC.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageToggleButtonC.vue?vue&type=style&index=0&id=d9f692ac&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9f692ac"]])

export default __exports__